export default function (value) {
  this.el.autofocus = Boolean(value)
}
